<template>

<v-col cols="12" class="pt-0 mt-5 bg-brilliant screenlock" v-if="keyboard.length > 0" style="padding-bottom:170px;">
  <v-row>
    <v-col cols="11" sm="12" md="12" lg="12" class="mx-auto  header-section text-center mt-5 pb-0 mb-0">
        <v-icon class="d-none d-md-flex" style="font-size:5em;" color="primary">mdi-lock</v-icon>
        <v-icon class="d-md-none" style="font-size:3em; margin-bottom:20px;" color="primary">mdi-lock</v-icon>
        <br>
        <h1 class="font-main pb-1 pt-0 mb-0 pb-5 yellow--text text--darken-2">
          Code de sécurité
        </h1>
        <small v-if="codeIsInited" class="font-papyrus d-inline-block my-1">
          Indiquez votre code de sécurité <br class="d-sm-none"> pour débloquer l'écran
        </small>
        <small v-if="!codeIsInited">
          <span class="font-papyrus d-inline-block my-1">
            Initialisez votre code de sécurité !
          </span><br>
          <small>
            Par sécurité, l'écran se vérouillera <br class="d-sm-none"> automatiquement lorsque vous serez inactif.
          </small>
        </small>
    </v-col>

    </v-row>

  <v-row>
    <v-col cols="11" sm="7" md="5" lg="4"
           class="mx-auto pb-0 header-section text-center">
      <small v-if="!codeIsInited">
        <small>
          <b>Indiquez un code à {{ defaultCodeSecurityLength }} chiffres, puis validez :</b>
        </small>
      </small>
    </v-col>
  </v-row>

  <v-row>
    <v-col cols="11" sm="5" md="5" lg="4" class="px-0 mx-auto col-keyboard">
      <div class="px-4 py-2 pb-1 chip-amount text-center primary--text">
        <span class="font-led ">{{ theCodeHidden }}</span>
      </div>
    </v-col>
  </v-row>

  <v-row>
    <v-col cols="10" sm="5" md="5" lg="4" class="px-0 mx-auto col-keyboard">
      <v-row class="mb-4 mx-0 text-center">
        <template v-for="i in keyboard">
          <v-col cols="4" :key="i" class="pa-1">
            <v-btn fab outlined color="primary" class="btn-key" @click="addNumToCode(i)">{{ i }}</v-btn>
          </v-col>
        </template>

        <v-col cols="4" class="pa-1">
          <v-btn fab outlined color="grey" @click="removeNumToCode()" class="btn-key">
            <v-icon>mdi-backspace-outline</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="4" class="pa-1">
          <v-btn fab outlined color="primary" class="btn-key" @click="addNumToCode(0)">0</v-btn>
        </v-col>
        <v-col cols="4" class="pa-1 text-center">
          <v-btn fab :loading="savingCode" :color="(codeCorrect || !codeIsInited) ? 'green' : 'red'" 
                class="btn-key" @click="validateCode()" 
                :disabled="!codeLenCorrect">
            <v-icon color="">mdi-{{ (codeCorrect || !codeIsInited) ? 'check' : (!codeLenCorrect ? 'check' : 'close') }}</v-icon>
          </v-btn>
        </v-col>
        <!-- <v-col cols="12" class="pa-1 mt-5 text-center">
          <v-btn icon outlined color="grey" @click="initKeyboard()" class="">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col> -->
      </v-row>
    </v-col>

    
  </v-row>

  <v-row>
    <v-col cols="11" sm="7" md="5" lg="3"
           class="mx-auto pb-0 header-section text-center">
      <v-card style="background:transparent;" outlined class="pa-2 mb-0">
        <span>
          <v-icon small color="">mdi-clock-fast</v-icon>
          Vérouiller l'écran après 
          <br class="d-sm-none"><b class="blue--text">{{ lockDelay }} minutes</b>
        </span>
        <v-slider hide-details :min="delayMin" :max="delayMax" :step="delayStep" v-model="lockDelay" color="blue">
          <template v-slot:prepend>
            <v-icon @click="decrement">mdi-minus</v-icon>
          </template>

          <template v-slot:append>
            <v-icon @click="increment">mdi-plus</v-icon>
          </template>
        </v-slider>
      </v-card>
    </v-col>
  </v-row>

  <v-row>
    <v-col cols="11" sm="7" md="5" lg="3" class="mx-auto mt-2 text-center" v-if="codeIsInited">
      <!-- <v-card style="background:transparent;" outlined class="pa-2 mb-0"> -->
      <v-btn block text  color="blue" class="mb-2" @click="startEditCode()" 
            :disabled="!codeLenCorrect || !codeCorrect" v-if="oldCodeEncrypted==null">
        <v-icon small color="">mdi-pencil</v-icon> <small>Modifier mon code</small>
      </v-btn>
      <small v-if="!codeCorrect"><small>Pour modifier votre code :<br>tapez d'abord votre code actuel.</small></small>
      <!-- </v-card> -->
    </v-col>
    <v-col cols="11" sm="7" md="5" lg="3" class="mx-auto mt-5 text-center"  v-else-if="oldCodeEncrypted!=null">
      <v-btn block color="" class="" @click="cancelEditCode()">
        <v-icon small class="pr-1">mdi-cancel</v-icon> <small>Annuler</small>
      </v-btn>
    </v-col>
  </v-row>

  <v-row>
    <v-col cols="11" sm="7" md="5" lg="3" class="mx-auto mt-5 text-center">
      <v-btn block color="" class="" @click="logout()">
        <v-icon small class="pr-1">mdi-logout</v-icon> <small>Se déconnecter</small>
      </v-btn>
    </v-col>
  </v-row>


</v-col>
  
</template>

<style >
.screenlock .col-keyboard{
  max-width:200px;
}
.screenlock .btn-key{
  /* height:36px !important; */
  font-size: 23px !important;
  /* margin-top:10px; */
}
.screenlock small{
  display: inline-block;
}
@media (max-width: 500px) {
  .screenlock .btn-key{
    /* height:30px !important; */
    font-size: 20px !important;
  }
}

.screenlock .header-section h1{
  font-size:50px !important;
  line-height:60px;
  margin-top:-50px;
}
@media (max-width: 600px) {
  .screenlock .header-section h1{
    font-size:30px !important;
    line-height:30px;
    margin-top:-20px;
  }
}
</style>

<script>

import crypto from "crypto"
import axios from 'axios'
import router from '../router/router'
import core from '../plugins/core.js'

//import Post from '@/components/Post.vue'
const config = require('../config/' + process.env.NODE_ENV)

export default {
  name: 'empty',
  components: {  },
  data: () => ({
    theCode: "",
    oldCodeEncrypted: null,
    keyboard: [],
    lockDelay: 15,
    delayMax: 60,
    delayMin: 5,
    delayStep: 5,

    savingCode: false,
    defaultCodeSecurity: null,
    defaultCodeSecurityLength: 5,
  }),
  async mounted(){
    //console.log(":LOCK screenlock page loaded")
    this.$store.dispatch("auth/setIsScreenlocked", true)

    this.lockDelay = this.$store.state.auth.user.lockDelay 
    this.oldCodeEncrypted = null
    this.defaultCodeSecurity = core.getDefaultCodeSecurity()
    this.defaultCodeSecurityLength = config.defaultCodeSecurityLength

    this.keyboard = [1,2,3,4,5,6,7,8,9]
    //this.initKeyboard()
  },
  methods: {
    initKeyboard(){ 
      let randKeys = []
      while(randKeys.length < 10){
        let rand = parseInt(Math.random() * 10)
        if(randKeys.indexOf(rand) === -1) randKeys.push(rand)
        console.log("rand", rand, randKeys)
      }
      this.keyboard = randKeys
    },  
    addNumToCode(num){
      if(this.theCode.length >= this.defaultCodeSecurityLength) return
      if(num == "." && this.theCode.indexOf(num) >= 0) return
      this.theCode = this.theCode + "" + num
    },
    removeNumToCode(){
      if(this.theCode.length <= 0) return
      this.theCode = this.theCode.substr(0, this.theCode.length-1)
      this.savingCode = false
    },
    async validateCode(){
      
      if(this.savingCode) return
      this.savingCode = true 

      let userCode = this.$store.state.auth.user.codeSecurity
      let encryptedCode = this.getEncryptedCode(this.theCode)
      console.log("userCode", userCode, encryptedCode)
      
      this.saveDelay()

      if(!this.codeIsInited){ 
        console.log("encryptedCode", encryptedCode)
        axios.post("/user/set-code-security", { oldCodeEncrypted: this.oldCodeEncrypted, 
                                                newCodeEncrypted : encryptedCode,
                                                lockDelay: this.lockDelay })
            .then((res)=>{
              if(!res.data.error){
                this.$store.dispatch("auth/setIsScreenlocked", false)
                this.$store.dispatch('auth/iamOnScreen')
                this.$store.dispatch('auth/refreshUserData')
                this.$store.dispatch('app/openSnackbar', 
                                      { show: true, color:'green', 
                                        title: "Votre nouveau code de sécurité a bien été enregistré",
                                        text: '', // this.$store.state.auth.user.currentMsg,
                                        icon: 'thumb-up' })
                router.push("/dashboard")
              }
              // else{
              //   console.log("error /user/init-code-security")
              // }
            })
            .catch(()=>{
              this.savingCode = false 
            })
      }
      else if(userCode == encryptedCode){
        this.$store.dispatch("auth/setIsScreenlocked", false)
        this.$store.dispatch('auth/upDateLock')
        this.$store.dispatch('auth/iamOnScreen')
        this.$store.dispatch('app/openSnackbar', 
                              { show: true, color:'yellow', 
                                title: "Ça fait plaisir de vous revoir !",
                                text: '',
                                icon: 'check' })

        return router.push("/dashboard")
      }
      else{
        this.theCode = ''
        this.savingCode = false 
        this.$store.dispatch('app/openSnackbar', 
                            { show: true, color:'red', 
                              title: "Code de sécurité incorrecte.",
                              text: '',
                              icon: 'lock'})
      }
    },
    saveDelay(){
      let encryptedCode = this.getEncryptedCode(this.theCode)
      this.$store.dispatch('auth/saveLockDelay', { newLockDelay: this.lockDelay, 
                                                   codeSecurityEnc: encryptedCode })
      this.$root.$emit("restartClockLocker")
    },
    getEncryptedCode(code) {
      //console.log("save session", session)
      // On définit notre algorithme de cryptage
      var algorithm = config.captcha.algorithm
      // // Notre clé de chiffrement, elle doit être la même pour le décryptage
      var cryptokey = config.captcha.cryptokey
      // Defining iv
      const iv = Buffer.alloc(16, 0);

      // // On crypte notre texte
      var cipher = crypto.createCipheriv(algorithm, cryptokey, iv)
      var codeEncrypted = cipher.update(code,'utf8','hex')
      codeEncrypted += cipher.final('hex')
      return codeEncrypted
    },
    startEditCode: function(){
      if(this.codeCorrect){
        this.$store.dispatch('auth/startEditCode')
        this.oldCodeEncrypted = this.getEncryptedCode(this.theCode)
        this.theCode = ""
      }
    },
    cancelEditCode: function(){
      if(this.oldCodeEncrypted != null){
        this.keyboard = []
        this.$store.dispatch('auth/iamOnScreen')
        this.$store.dispatch('auth/refreshUserData')
        router.back()
      }
    },
    decrement: function(){
      if(this.lockDelay <= this.delayMin) return
      this.lockDelay -= this.delayStep
    },
    increment: function(){
      if(this.lockDelay >= this.delayMax) return
      this.lockDelay += this.delayStep
    },
    logout(){
      this.$store.dispatch('auth/logout')
    }
  },
  computed: {
    theCodeHidden(){ 
      let hidden = ""
      for(let i = 0; i < this.theCode.length; i++)
        hidden += "*"

      for(let i = 0; hidden.length < this.defaultCodeSecurityLength; i++)
        hidden += "_"

      return hidden
    },
    codeIsInited(){
      console.log("this.defaultCodeSecurity", this.$store.state.auth.user.codeSecurity , this.defaultCodeSecurity)
      return this.$store.state.auth.user.codeSecurity != this.defaultCodeSecurity //"****" //core.getDefaultCodeSecurity()
    },
    codeCorrect(){
      let encryptedCode = this.getEncryptedCode(this.theCode)
      return (this.$store.state.auth.user.codeSecurity == encryptedCode)
    },
    codeLenCorrect(){
      return this.theCode.length == this.defaultCodeSecurityLength
    }
    
  },


  watch: {
    // 'codeCorrect': { immediate: true, 
    //     async handler () {
    //       //console.log("alo", this.entityParent, this.entityParent == null)
    //       if(this.codeCorrect) this.validateCode()
    //     }
    // },
  }
}
</script>
